module.exports = __webpack_public_path__ + "img/AF-Aislante.1ef5da69.png";